import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import { useFormik } from "formik";
import axios from "../api/axios";
import {  Apitoken, Authtoken } from '../Global';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const EditCalledCantacts = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [backendErrors, setBackendErrors] = useState([]);
  const [labelname, seLabelname] = useState('');
 

  useEffect(() => {
    axios
      .get(`/called-contacts/edit/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.contact);
            if(response.data.data.contact.type == 'Business'){
              seLabelname('Called Contacts: Business')
            }
            if(response.data.data.contact.type == 'Logistics'){
                seLabelname('Called Contacts: Logistic')
            }
            if(response.data.data.contact.type == 'Qualities'){
                seLabelname('Called Contacts: Quality')
            }
        }
       
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const {
    values,
  
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      id: value.id,
      type: value.type,
      name: value.name,
      email: value.email,
      phone_number: value.phone_number,
      position: value.position,
    },
    enableReinitialize: true,

    onSubmit: (values, actions) => { 
         axios
        .post("/called-contacts/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          $("#form-submit").text("Update season");
          delete backendErrors['error'];
          actions.setSubmitting(false);
          if (response.data.code === 200) {
            toast.success(response.data.message);
            setTimeout(() => {
              window.location.href = "/called-contacts";
            }, 500);
          }
            else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          console.log(error)
        });
    },
  });

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

const customHandleInput = (event) => {
  const Input_name = event.target.name;
  delete backendErrors[Input_name];
};


  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /><ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">{labelname}</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/payment-terms">Payment Terms</Link>
                    </li>
                    <li className="breadcrumb-item active">Edit</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">{labelname} </h4>
                    <form action="#" onSubmit={handleSubmit}>
                    
   
                        <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label> Name</label>
                            <input
                              type="text"
                              name="name"
                              value={values.name}
                              className= "form-input form-control"
                           
                              onChange={(e) => {
                                handleChange(e);
                                customHandleInput(e);
                              }}
                               onBlur={handleBlur}
                               placeholder="Enter Season Name"
                            />
                           <small>
                              {backendErrors.name && (
                                <span className="form-error mt-1">
                                  {backendErrors.name}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        
                        <div className="col-md-3">
                          <div className="form-group">
                            <label> Email</label>
                           
                                <div className="input-group">
                                <input 
                                   type="text"
                                  
                                  name="email"
                                  value={values.email}
                                  onChange={(e) => {
                                    handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={handleBlur}
                                  className="form-control" placeholder="Enter Email" />
                              </div>


                           <small>
                              {backendErrors.email && (
                                <span className="form-error mt-1">
                                  {backendErrors.email}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label> Phone Number</label>
                             <div className="input-group">
                                  <input 
                                   type="text"
                                  
                                  name="phone_number"
                                  value={values.phone_number}
                                  onChange={(e) => {
                                    handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={handleBlur}
                                  className="form-control" placeholder="Enter Phone Number" />
                                 
                              </div>
                           <small>
                              {backendErrors.phone_number && (
                                <span className="form-error mt-1">
                                  {backendErrors.phone_number}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        
                        <div className="col-md-3">
                          <div className="form-group">
                            <label> Position</label>
                             <div className="input-group">
                                  <input 
                                   type="text"
                                  
                                  name="position"
                                  value={values.position}
                                  onChange={(e) => {
                                    handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={handleBlur}
                                  className="form-control" placeholder="Enter Position" />
                                 
                              </div>
                           <small>
                              {backendErrors.position && (
                                <span className="form-error mt-1">
                                  {backendErrors.position}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        
                   
                        
                    
                       
                      </div>

                        <small>
                              {backendErrors.status  && (
                                <span className="form-error mt-1">
                                  {backendErrors.status}
                                </span>
                              )}
                        </small>
                            <div className="text-end mt-4">
                                <button type="submit" id="form-submit" className="btn btn-primary" disabled={isSubmitting}>  Update  </button>
                            </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default EditCalledCantacts;
